import React, { useEffect, useState } from "react";
import TabsNavbar from "../../Common/TabsNavBar/TabsNavbar";
import NewRevendeurContent from "./NewRevendeurContent";
import Button from "../../Common/FormElements/Button/Button";
import { useDispatch, useSelector } from "react-redux";
import {
  accompanimentForm,
  billingAddressForm,
  contractForm,
  deliveryAddressForm,
  noteForm,
  resellerForm,
} from "./data";
import {
  createUpdateReseller,
  getCurrentReseller,
} from "../../../REDUX/actions/reseller";
import {
  closeRightModal,
  openRightModal,
} from "../../../REDUX/actions/rightModal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeftLong } from "@fortawesome/free-solid-svg-icons";
import UpdateTicketSav from "../../Sav/UpdateTicketSavAdmin/UpdateTicketSav";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { isDefined } from "../../../Utils";
import { getFavorites, resetFavorites } from "../../../REDUX/actions/favorites";
import { interlocutorForm } from "../../Prospects/NewProspect/data";

function NewRevendeur({ id, savID }) {
  const { t } = useTranslation("common");
  const dispatch = useDispatch();
  const { currentResellerLoading: loading, currentReseller } = useSelector(
    (state) => state?.resellerReducer,
  );
  const { favorites } = useSelector((state) => state.favoriteReducer);
  const [activeTab, setActiveTab] = useState("Informations");
  const [invalidFields, setInvalidFields] = useState([]);
  const [customErrors, setCustomErrors] = useState({});
  const [deletedInterlocutors, setDeletedInterlocutors] = useState([]);
  const [disabled, setDisabled] = useState(true);
  const [forms, setForms] = useState({
    infos: {},
    addresses: {
      billing: {},
      delivery: {},
    },
    note: {},
    contract: {},
    accompaniment: {},
    interlocutors: [],
    comments: {},
    geoEntity: {},
  });
  const tabs = [
    "Informations",
    "Note",
    "Contract",
    "Accompaniment",
    "Interlocutors",
    "Location",
    "Addresses",
    "Comments",
  ];

  if (favorites?.length > 0) {
    tabs.push("Favorites");
  }
  const location = useLocation();

  const getRenderedTabs = (tabs = []) => {
    return tabs;
  };

  const checkFormValidation = () => {
    const updatedInvalidFields = [];
    resellerForm?.forEach(({ name, required }) => {
      if (required) {
        if (
          forms.infos[name] === undefined ||
          forms.infos[name] === null ||
          !String(forms.infos[name])?.trim()?.length > 0
        ) {
          updatedInvalidFields.push(name);
        }
      }
    });
    if (updatedInvalidFields?.length > 0) {
      setDisabled(true);
    } else {
      setDisabled(false);
    }
    setInvalidFields(updatedInvalidFields);
  };

  const handleClick = () => {
    const phoneNumberPattern = /^(\+|\d{1,4})\s?(\d\s?){5,}$/;
    if (!forms.infos.phoneNumber.match(phoneNumberPattern)) {
      setCustomErrors({
        ...customErrors,
        phoneNumber: "phoneNumberError",
      });

      return;
    }
    const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!forms.infos.email.match(emailPattern)) {
      setCustomErrors({
        ...customErrors,
        email: "emailError",
      });
      return;
    }
    dispatch(
      createUpdateReseller(
        { ...forms },
        currentReseller?.id,
        deletedInterlocutors,
        () => dispatch(closeRightModal()),
        t,
      ),
    );
  };
  useEffect(() => {
    setForms((currState) => {
      const updatedFormData = { ...currState };
      accompanimentForm.forEach(({ name, type }) => {
        if (type === "multiSelect") {
          updatedFormData.accompaniment[name] =
            currentReseller?.attributes?.assistance?.data?.attributes[
              name
            ]?.data?.map(({ id }) => id);
        } else {
          updatedFormData.accompaniment[name] =
            currentReseller?.attributes?.assistance?.data?.attributes[name];
        }
      });
      contractForm.forEach(({ name, type }) => {
        if (type === "multiSelect") {
          updatedFormData.contract[name] =
            currentReseller?.attributes?.contract?.data?.attributes[
              name
            ]?.data?.map(({ id }) => id);
        } else {
          updatedFormData.contract[name] =
            currentReseller?.attributes?.contract?.data?.attributes[name];
        }
      });

      updatedFormData.geoEntity = {
        markers:
          currentReseller?.attributes?.geoEntity?.data?.attributes?.markers,
        turfs: currentReseller?.attributes?.geoEntity?.data?.attributes?.turfs,
      };
      noteForm.forEach(({ name }) => {
        updatedFormData.note[name] =
          currentReseller?.attributes?.note?.data?.attributes[name];
      });
      resellerForm.forEach(({ name, type }) => {
        if (type === "multiSelect") {
          updatedFormData.infos[name] = currentReseller?.attributes[
            name
          ]?.data?.map(({ id }) => id);
        } else {
          if (name === "business_affiliate") {
            updatedFormData.infos[name] =
              currentReseller?.attributes?.business_affiliate?.data?.id;
          } else if (name === "spaMarques") {
            updatedFormData.infos[name] =
              currentReseller?.attributes?.spaMarques?.data?.map(
                (marque) => marque?.id,
              );
          } else {
            updatedFormData.infos[name] = currentReseller?.attributes[name];
          }
        }
      });

      updatedFormData.interlocutors =
        currentReseller?.attributes?.interlocutors?.data?.map((inter) => {
          return interlocutorForm.reduce(
            (acc, { name }) => {
              acc[name] = inter?.attributes[name];
              return acc;
            },
            { id: inter?.id, photo: inter?.attributes?.photo?.data },
          );
        });

      currentReseller?.attributes?.delivery_addresses?.data?.length > 0 &&
        deliveryAddressForm.forEach(({ name, type }) => {
          if (type === "select") {
            updatedFormData.addresses.delivery[name] = {
              name: currentReseller?.attributes?.delivery_addresses?.data[0]
                ?.attributes[name]?.data?.attributes?.name,
              code: currentReseller?.attributes?.delivery_addresses?.data[0]
                ?.attributes[name]?.data?.id,
            };
          } else {
            updatedFormData.addresses.delivery[name] =
              currentReseller?.attributes?.delivery_addresses?.data[0]?.attributes[
                name
              ];
          }
        });

      currentReseller?.attributes?.billingAddress?.data?.length > 0 &&
        billingAddressForm.forEach(({ name, type }) => {
          if (type === "select") {
            updatedFormData.addresses.billing[name] = {
              name: currentReseller?.attributes?.billingAddress?.data[0]
                ?.attributes[name]?.data?.attributes?.name,
              code: currentReseller?.attributes?.billingAddress?.data[0]
                ?.attributes[name]?.data?.id,
            };
          } else {
            updatedFormData.addresses.billing[name] =
              currentReseller?.attributes?.billingAddress?.data[0]?.attributes[
                name
              ];
          }
        });

      updatedFormData.affiliate = {
        name: `${
          currentReseller?.attributes?.business_affiliate?.data?.attributes
            ?.company ?? ""
        }`,
        code: currentReseller?.attributes?.business_affiliate?.data?.id,
      };

      return updatedFormData;
    });
  }, [currentReseller]);

  useEffect(() => {
    checkFormValidation();
  }, [forms]);

  useEffect(() => {
    dispatch(getCurrentReseller(id));
  }, [id, dispatch]);

  useEffect(() => {
    if (!isDefined(id)) return;

    dispatch(getFavorites(id, "reseller"));

    return () => dispatch(resetFavorites());
  }, [id, dispatch]);

  /* ******************************** Rendering ******************************* */
  return (
    <div className="newRevendeur d-flex flex-column justify-content-between h100">
      <div className="flex-1 d-flex flex-column">
        <div className="alignH align-items-end">
          {location.pathname === "/sav" && (
            <FontAwesomeIcon
              icon={faArrowLeftLong}
              size={"xl"}
              className="ps-5 mb-5 pointer text-blue"
              onClick={() =>
                dispatch(openRightModal(<UpdateTicketSav id={savID} />))
              }
            />
          )}
          <h2
            className={`sBold f25 quickSand text-blue ${
              location.pathname === "/sav" ? "px-3" : "px-5"
            } mb-5`}
          >
            {id ? t("Modify the reseller") : t("Add new reseller")}
          </h2>
        </div>
        <TabsNavbar
          tabs={getRenderedTabs(tabs)}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          className={tabs?.length > 5 ? "gap-3" : "gap-5"}
          disabledIndexes={currentReseller ? [] : [5, 6]}
        />
        <NewRevendeurContent
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          forms={forms}
          setForms={setForms}
          customErrors={customErrors}
          updateDeletedInterlocutors={setDeletedInterlocutors}
        />
        {activeTab !== "Addresses" && activeTab !== "Comments" && (
          <div className="buttonsContainer d-flex justify-content-center mt-auto">
            <Button variant="outline" className="me-4">
              {t("Cancel")}
            </Button>
            <Button
              loading={loading}
              disabled={disabled}
              onClick={loading ? undefined : handleClick}
            >
              {t("Save")}
            </Button>
          </div>
        )}
      </div>
    </div>
  );
}

export default NewRevendeur;
